import React, { useContext, useState } from "react";
import { useForm, Controller } from 'react-hook-form';
import { CustomButtonsForm } from "../../CustomButtonsForm";
import { CustomInputArea } from "../../CustomInputArea";
import { CustomInputText } from "../../CustomInputText";
import { CustomInputSelect } from "../../CustomInputSelect";
import { CloseOutlined, CloudUploadOutlined } from "@mui/icons-material";
import { useUsers } from "../../../hooks/useUsers";
import { useCategories } from "../../../hooks/activos/useCategories";
import { IconButton } from "@mui/material";
import { AlertContext } from "../../../contexts/AlertContext";
import { motion, AnimatePresence } from 'framer-motion';
import { formatearPesos, formatearValor } from "../../../helpers/formatearPesos";
import { convertirLetraMayus } from "../../../helpers/convertirLetraMayus";

export const UpdateAssetForm = ({ data, action }) => {

	console.log(data);

	const [selectedImage, setSelectedImage] = useState('');
	const [previousImage, setPreviousImage] = useState(data?.imagen?.secure_url);
	const { users } = useUsers();
	const { alertRef } = useContext(AlertContext);
	const { categories } = useCategories();
	const { handleSubmit, control, formState:{ errors }, register } = useForm();

	const changeImage = (e) => {
		if(!e.target.files[0]) return;

		const extension = e.target.files[0]?.name?.split('.').at(-1);
		const extensionesPermitidas = ['png', 'jpg', 'jpeg'];

		if(!extensionesPermitidas?.includes(extension)) {
			return alertRef?.current?.handleOpen('error', `La extensión ${ extension } no es permitida, intente con (${ extensionesPermitidas.join(', ') })`);
		}

		setPreviousImage(URL.createObjectURL(e.target.files[0]));

		setSelectedImage({
			//public_id: data?.imagen?.public_id?.split('/')?.at(-1) || '',
			public_id: data?.imagen?.public_id || '',
			name: e.target.files[0]?.name,
			type: e.target.files[0]?.type,
			buffer: e.target.files[0]
		});
	}

	const removeImage = () => {
		setPreviousImage('');
		setSelectedImage('');
	}

	return (
		<form onSubmit={ handleSubmit((args) => action({ ...args, imagen: selectedImage, _idResponsable: data?.historial_responsables?.at(-1)?._id })) } 
			style={{ 
				background: "#fff",
				width: '35vw',
				padding: 20,
				overflowY: 'auto',
				scrollbarWidth: 'none'
			}}
		>
			<Controller 
				name='descripcion'
				control={ control }
				defaultValue={ convertirLetraMayus(data?.descripcion) || '' }
				render={ ({ field: { onChange, value } }) => (
					<CustomInputArea 
						label='Descripción'
						placeholder=''
						onChange={ onChange }
						value={ value }
						error={ errors?.descripcion }
					/>
				)}

				rules={{ required: '* El campo es obligatorio.' }}
			/>

			<Controller 
					name='ubicacion'
					control={ control }
					defaultValue={ convertirLetraMayus(data?.ubicacion) || '' }
					render={ ({ field: { onChange, value } }) => (
						<CustomInputText
							label='Ubicación'
							placeholder=''
							onChange={ onChange }
							value={ value }
							error={ errors?.ubicacion }
						/>
					)}

					rules={{ required: '* El campo es obligatorio.' }}
				/>

			<div
				style={{
					display: 'flex',
					flexWrap: 'wrap',
					gap: 15
				}}
			>
				<Controller 
					name='placa'
					control={ control }
					defaultValue={ data?.placa || '' }
					render={ ({ field: { onChange, value } }) => (
						<CustomInputText
							label='Número de placa'
							placeholder=''
							onChange={ (e) => onChange(formatearPesos(e?.target?.value)) }
							value={ value }
							error={ errors?.placa }
						/>
					)}

					rules={{
						required: '* El campo es obligatorio.'
					}}
				/>

				<Controller 
					name='codigo_inteligente'
					control={ control }
					defaultValue={ data?.codigo_inteligente?.toUpperCase() || '' }
					render={ ({ field: { onChange, value } }) => (
						<CustomInputText
							disabled={ true }
							label='Código inteligente'
							placeholder=''
							onChange={ (e) => onChange(formatearPesos(e?.target?.value)) }
							value={ value }
							error={ errors?.codigo_inteligente }
						/>
					)}

					rules={{
						required: '* El campo es obligatorio.'
					}}
				/>
			</div>

			<Controller 
				name='responsable'
				control={ control }
				// defaultValue={ data?.historial_responsables.at(-1)?.usuario?._id || '' }
				defaultValue={ data?.responsable?.usuario?._id || '' }
				render={ ({ field: { onChange, value } }) => (
					<CustomInputSelect
						label='Responsable'
						options={ users?.map(user => ({ ...user, name: user?.nombre })) }
						onChange={ onChange }
						value={ value }
						error={ errors?.responsable }
					/>
				)}

				rules={{ required: '* El campo es obligatorio.' }}
			/>

			<div
				style={{
					display: 'flex',
					flexWrap: 'wrap',
					gap: 15
				}}
			>
				<Controller 
					name='fecha_compra'
					control={ control }
					defaultValue={ data?.fecha_compra || '' }
					render={ ({ field: { onChange, value } }) => (
						<CustomInputText
							disabled={ true }
							label='Fecha de compra'
							type='date'
							placeholder=''
							onChange={ onChange }
							value={ value }
							error={ errors?.fecha_compra }
						/>
					)}

					rules={{ required: '* El campo es obligatorio.' }}
				/>

				<Controller 
					name='valor_compra'
					control={ control }
					defaultValue={ data?.valor_compra || '' }
					render={ ({ field: { onChange, value } }) => (
						<CustomInputText
							disabled={ true }
							label='Valor de compra'
							placeholder=''
							onChange={ (e) => onChange(formatearPesos(e?.target?.value)) }
							value={ formatearValor(value) || "" }
							error={ errors?.valor_compra }
						/>
					)}

					rules={{ required: '* El campo es obligatorio.' }}
				/>
			</div>

			<Controller 
				name='observacion'
				control={ control }
				defaultValue={ convertirLetraMayus(data?.observacion) || '' }
				render={ ({ field: { onChange, value } }) => (
					<CustomInputArea 
						label='Observación'
						placeholder=''
						onChange={ onChange }
						value={ value }
						error={ errors?.observacion }
						rows={2}
					/>
				)}
			/>

			<Controller 
				name='categoria'
				control={ control }
				defaultValue={ data?.categoria?._id || '' }
				render={ ({ field: { onChange, value } }) => (
					<CustomInputSelect 
						disabled={ true }
						label='Categoria'
						options={ categories?.map(category => ({ ...category, name: category?.nombre })) }
						onChange={ onChange }
						value={ value }
						error={ errors?.categoria }
					/>
				)}

				rules={{ required: '* El campo es obligatorio.' }}
			/>

			<div
				style={{
					position: 'relative',
					marginBottom: 15,
					border: '2px dashed #a3a3a3',
					borderRadius: 4,
					minHeight: 115,
					height: 'auto'
				}}
			>
				{
					!previousImage && (
						<motion.div
							initial={{ opacity: 0 }}
							animate={{ opacity: 1 }}
							exit={{ opacity: 0 }}
						>
							<label htmlFor="file" style={{ 
								fontWeight: 550,
								fontSize: 12,
								color: '#a3a3a3',
								cursor: 'pointer',
								position: 'absolute',
								top: '50%',
								left: '50%',
								transform: 'translate(-50%, -50%)'
							}}>
								<div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
									<CloudUploadOutlined />
									Seleccionar imagen
								</div>
							</label>
							<input
								id='file' 
								type="file"
								accept="image/png, image/jpeg, image/jpg"
								onChange={ changeImage }
								aria-label="Seleccionar imagen"
								style={{ display: 'none' }}
							/>
						</motion.div>
					)
				}

				<AnimatePresence initial={ false }>
					{
						previousImage && (		
							<motion.div
								initial={{ opacity: 0 }}
								animate={{ opacity: 1 }}
								exit={{ opacity: 0 }}
	
								style={{ 
									position: 'relative', 
									background: 'tomato', 
									display: 'flex', 
									width: 'fit-content', 
									borderRadius: 4, 
									overflow: 'hidden', 
									margin: 5 
								}}
							>
								<img src={ previousImage } alt='previous image' width={100} height={100} style={{ position: 'relative'}} />
								<div style={{ position: 'absolute', background: '#000', width: 20, height: 20, opacity: .8, borderRadius: '50%', top: 5, right: 5 }} />
					
								<IconButton style={{ position: 'absolute', top: 0, right: 0 }} onClick={ removeImage }>
									<CloseOutlined htmlColor="#fff" style={{ color: '#fff', fontSize: 14 }} />
								</IconButton>
							</motion.div>
						)
					}
				</AnimatePresence>
			</div>

			<CustomButtonsForm name='Guardar' />
		</form>
	)
}